import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import * as S from './style';
import OtherTextInput from './other-text-input';

const DropdownInput = ({ name, error, touched, options }) => {
  const { t } = useTranslation();
  const [showOther, setShowOther] = useState(false);
  const { setFieldValue } = useFormikContext();

  const { variants, invertKeys, addOther, tkeys } = options;

  useEffect(() => {
    if (!variants) {
      console.error(name, 'field is missing options!');
    }
  }, []);

  if (!variants) {
    return null;
  }

  const selectOptions = Object.entries(variants).map(([value, text]) => ({
    value: invertKeys ? text : value,
    label: text,
  }));

  if (addOther) selectOptions.push({ label: t('Other'), value: 'Other' });

  const onChangeHandle = (select) => {
    const { value } = select[0];
    if (['Photo Community_A1', 'Other'].includes(value)) {
      setFieldValue(name, '');
      setShowOther(true);
    } else {
      setFieldValue(name, value);
      setShowOther(false);
    }
  };

  return (
    <>
      <Field
        name={name}
        as="select"
        multi={false}
        placeholder={t('Select')}
        component={S.DropdownSelect}
        className={error ? 'error' : touched && 'valid'}
        onChange={onChangeHandle}
        options={selectOptions}
      />
      {showOther ? (
        <OtherTextInput name={name} error={error} touched={touched} t={t} tkey={tkeys[0]} />
      ) : null}
    </>
  );
};

export default DropdownInput;

DropdownInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  options: PropTypes.object,
};
